import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AppRole } from '../api/me';
import { CurrentUserService } from './current-user.service';

/**
 * Пускает только пользователей с назначенной ролью (любой, если список пуст).
 * Роли берутся из `data.roles` маршрута — оттуда же их читает меню shell,
 * поэтому права и список разделов не расходятся.
 * Без роли — заглушка /no-role; с чужой ролью — /forbidden.
 * Ставится после autoLoginPartialRoutesGuard, который гарантирует вход.
 */
export function roleGuard(...roles: AppRole[]): CanActivateFn {
    return async (route: ActivatedRouteSnapshot) => {
        const currentUser = inject(CurrentUserService);
        const router = inject(Router);

        try {
            await currentUser.load();
        } catch {
            // 403 обрабатывает accessErrorInterceptor (портал или /no-role); прочие ошибки — сообщение
            return router.createUrlTree(['/error']);
        }

        const required = roles.length > 0 ? roles : readRouteRoles(route);

        if (!currentUser.hasRole()) return router.createUrlTree(['/no-role']);
        if (required.length > 0 && !currentUser.hasAnyRole(required)) {
            return router.createUrlTree(['/forbidden']);
        }
        return true;
    };
}

function readRouteRoles(route: ActivatedRouteSnapshot): readonly AppRole[] {
    const roles: unknown = route.data?.['roles'];
    return Array.isArray(roles) ? (roles as readonly AppRole[]) : [];
}
